/*==================================================================================================

Application:   Utility Function
Author:        John Gardner

Version:       V1.0
Date:          18th November 2003
Description:   Used to check the validity of a UK postcode

Version:       V2.0
Date:          8th March 2005
Description:   BFPO postcodes implemented.
			   The rules concerning which alphabetic characters are allowed in which part of the 
			   postcode were more stringently implementd.
  
Version:       V3.0
Date:          8th August 2005
Description:   Support for Overseas Territories added                 
  
Version:       V3.1
Date:          23rd March 2008
Description:   Problem corrected whereby valid postcode not returned, and 'BD23 DX' was invalidly 
			   treated as 'BD2 3DX' (thanks Peter Graves)        
  
Version:       V4.0
Date:          7th October 2009
Description:   Character 3 extended to allow 'pmnrvxy' (thanks to Jaco de Groot)  

Version:       V4.1
			   8th September 2011
			   Support for Anguilla overseas territory added    
			   
Version:       V5.0
Date:          8th November 2012
			   Specific support added for new BFPO postcodes           
  
Parameters:    toCheck - postcodeto be checked. 

This function checks the value of the parameter for a valid postcode format. The space between the 
inward part and the outward part is optional, although is inserted if not there as it is part of the 
official postcode.

If the postcode is found to be in a valid format, the function returns the postcode properly 
formatted (in capitals with the outward code and the inward code separated by a space. If the 
postcode is deemed to be incorrect a value of false is returned.
  
Example call:
  
  if (checkPostCode (myPostCode)) {
	alert ("Postcode has a valid format")
  } 
  else {alert ("Postcode has invalid format")};
					
--------------------------------------------------------------------------------------------------*/

window.checkPostCode = function (toCheck) {

	// Permitted letters depend upon their position in the postcode.
	var alpha1 = "[abcdefghijklmnoprstuwyz]";                       // Character 1
	var alpha2 = "[abcdefghklmnopqrstuvwxy]";                       // Character 2
	var alpha3 = "[abcdefghjkpmnrstuvwxy]";                         // Character 3
	var alpha4 = "[abehmnprvwxy]";                                  // Character 4
	var alpha5 = "[abdefghjlnpqrstuwxyz]";                          // Character 5
	var BFPOa5 = "[abdefghjlnpqrst]";                               // BFPO alpha5
	var BFPOa6 = "[abdefghjlnpqrstuwzyz]";                          // BFPO alpha6

	// Array holds the regular expressions for the valid postcodes
	var pcexp = new Array ();

	// BFPO postcodes
	pcexp.push (new RegExp ("^(bf1)(\\s*)([0-6]{1}" + BFPOa5 + "{1}" + BFPOa6 + "{1})$","i"));

	// Expression for postcodes: AN NAA, ANN NAA, AAN NAA, and AANN NAA
	pcexp.push (new RegExp ("^(" + alpha1 + "{1}" + alpha2 + "?[0-9]{1,2})(\\s*)([0-9]{1}" + alpha5 + "{2})$","i"));

	// Expression for postcodes: ANA NAA
	pcexp.push (new RegExp ("^(" + alpha1 + "{1}[0-9]{1}" + alpha3 + "{1})(\\s*)([0-9]{1}" + alpha5 + "{2})$","i"));

	// Expression for postcodes: AANA  NAA
	pcexp.push (new RegExp ("^(" + alpha1 + "{1}" + alpha2 + "{1}" + "?[0-9]{1}" + alpha4 +"{1})(\\s*)([0-9]{1}" + alpha5 + "{2})$","i"));

	// Exception for the special postcode GIR 0AA
	pcexp.push (/^(GIR)(\s*)(0AA)$/i);

	// Standard BFPO numbers
	pcexp.push (/^(bfpo)(\s*)([0-9]{1,4})$/i);

	// c/o BFPO numbers
	pcexp.push (/^(bfpo)(\s*)(c\/o\s*[0-9]{1,3})$/i);

	// Overseas Territories
	pcexp.push (/^([A-Z]{4})(\s*)(1ZZ)$/i);  

	// Anguilla
	pcexp.push (/^(ai-2640)$/i);

	// Load up the string to check
	var postCode = toCheck;

	// Assume we're not going to find a valid postcode
	var valid = false;

	// Check the string against the types of post codes
	for (var i = 0; i < pcexp.length; i++) {

		if (pcexp[i].test(postCode)) {

			// The post code is valid - split the post code into component parts
			pcexp[i].exec(postCode);

			// Copy it back into the original string, converting it to uppercase and inserting a space 
			// between the inward and outward codes
			postCode = RegExp.$1.toUpperCase() + " " + RegExp.$3.toUpperCase();

			// If it is a BFPO c/o type postcode, tidy up the "c/o" part
			postCode = postCode.replace (/C\/O\s*/,"c/o ");

			// If it is the Anguilla overseas territory postcode, we need to treat it specially
			if (toCheck.toUpperCase() == 'AI-2640') {
				postCode = 'AI-2640'
			};

			// Load new postcode back into the form element
			valid = true;

			// Remember that we have found that the code is valid and break from loop
			break;
		}
	}

	// Return with either the reformatted valid postcode or the original invalid postcode
	if (valid) {
		return postCode;
	}
	return false;
}

// Validate the field
window.fieldHasError = function (field) {

	// Don't validate submits, buttons, file and reset inputs, and disabled fields
	if (field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') return;

	// Get validity
	var validity = field.validity;

	var errorMessage = '';

	// If valid, return null
	if (validity.valid)
		return false;

	// If field is required and empty
	if (validity.valueMissing)
		errorMessage = 'Please fill out this field.';

	// If not the right type
	if (validity.typeMismatch) {

		// Email
		if (field.type === 'email')
			errorMessage = 'Please enter an email address.';

		// URL
		if (field.type === 'url')
			errorMessage = 'Please enter a URL.';
	}

	// If too short
	if (validity.tooShort) 
		errorMessage = 'Please lengthen this text to ' + field.getAttribute('minLength') + ' characters or more. You are currently using ' + field.value.length + ' characters.';

	// If too long
	if (validity.tooLong)
		errorMessage = 'Please shorten this text to no more than ' + field.getAttribute('maxLength') + ' characters. You are currently using ' + field.value.length + ' characters.';

	// If number input isn't a number
	if (validity.badInput)
		errorMessage = 'Please enter a number.';

	// If a number value doesn't match the step interval
	if (validity.stepMismatch)
		errorMessage = 'Please select a valid value.';

	// If a number field is over the max
	if (validity.rangeOverflow)
		errorMessage = 'Please select a value that is no more than ' + field.getAttribute('max') + '.';

	// If a number field is below the min
	if (validity.rangeUnderflow)
		errorMessage = 'Please select a value that is no less than ' + field.getAttribute('min') + '.';
  
	  // If pattern doesn't match
	if (validity.patternMismatch) {

		// If pattern info is included, return custom error
		if (field.hasAttribute('title'))
			errorMessage = field.getAttribute('title');

		// Otherwise, generic error
		errorMessage = 'Please match the requested format.';
	}

	// If all else fails, return a generic catchall error
	errorMessage = 'The value you entered for this field is invalid.';

	return true;
};